import { useCallback, useEffect, useState } from 'react'
import taskLinksAPI from 'features/taskLinks/taskLinksAPI'

const entries = new Map()

const entryFor = taskId => {
  if (!entries.has(taskId)) entries.set(taskId, { result: null, inflight: false, seq: 0, listeners: new Set() })
  return entries.get(taskId)
}

const load = (taskId, force = false) => {
  const entry = entryFor(taskId)
  if (entry.inflight && !force) return
  entry.seq += 1
  const seq = entry.seq
  entry.inflight = true
  taskLinksAPI.taskRelated(taskId)
    .then(res => ({ data: res?.data?.data || null, failed: false }))
    .catch(() => ({ data: null, failed: true }))
    .then(result => {
      if (seq !== entry.seq) return
      entry.inflight = false
      entry.result = result
      entry.listeners.forEach(listener => listener(result))
      if (!entry.listeners.size && entries.get(taskId) === entry) entries.delete(taskId)
    })
}

const useTaskRelated = taskId => {
  const [result, setResult] = useState(null)

  useEffect(() => {
    if (!taskId) {
      setResult(null)
      return undefined
    }
    const entry = entryFor(taskId)
    setResult(entry.result)
    entry.listeners.add(setResult)
    if (!entry.result && !entry.inflight) load(taskId)
    return () => {
      entry.listeners.delete(setResult)
      if (!entry.listeners.size && !entry.inflight && entries.get(taskId) === entry) entries.delete(taskId)
    }
  }, [taskId])

  const refresh = useCallback(() => {
    if (taskId) load(taskId, true)
  }, [taskId])

  return { result, refresh }
}

export default useTaskRelated
